import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import styles from "./DeleteBlogModal.module.css";

export default function DeleteBlogModal({
  open,
  title,
  description,
  loading = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className={styles.backdrop} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.icon}>
          <FiAlertTriangle />
        </div>
        <h3>{title || "Are you sure?"}</h3>
        <p>{description || "This action cannot be undone."}</p>
        <div className={styles.actions}>
          <button type="button" className={styles.cancel} onClick={onCancel} disabled={loading}>
            Cancel
          </button>
          <button type="button" className={styles.confirm} onClick={onConfirm} disabled={loading}>
            {loading ? "Processing..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
}
